import { faChevronDown } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Checkbox, Collapse } from '@nexelem/deprecated-theme';
import { IconButton } from '@nexelem/components';
import clsx from 'clsx';
import { MouseEventHandler, useState } from 'react';
import { QueueAvailability } from './QueueAvailability';
import { useCustomTranslation } from '../../../../../hooks';

// TODO: add correct data
const MOCK_WORKSTATION = {
  name: 'Obszar fioletowy1',
  id: 'OBSZ_FIO1',
  area: 'Obszar fioletowy',
  availableWorkstations: 5,
  totalWorkstations: 6,
};

export const AvailabilityArea = () => {
  const { tWrapper } = useCustomTranslation('products.productionPlan');
  const [isExpanded, setIsExpanded] = useState(false);
  const [checked, setChecked] = useState(false);

  const handleCheck: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.stopPropagation();
    setChecked(!checked);
  };

  return (
    <div className="overflow-hidden rounded-xs border border-border-container">
      <div
        className="flex h-15 cursor-pointer items-center gap-2 bg-surface-secondary px-2 has-[:checked]:bg-surface-focus-lighter"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <Checkbox disableRipple checked={checked} size="small" onClick={handleCheck} />
        <span className="h-4 min-h-4 w-4 min-w-4 rounded-full bg-surface-action"></span>
        <span className="text-s18-sb">{MOCK_WORKSTATION.name}</span>
        <span className="text-s18 text-text-secondary-darker">
          ({tWrapper('availableWorkstations')} {MOCK_WORKSTATION.availableWorkstations}/
          {MOCK_WORKSTATION.totalWorkstations})
        </span>
        <IconButton
          className="ml-auto"
          Icon={() => (
            <FontAwesomeIcon className={clsx('text-icon-action', isExpanded && 'rotate-180')} icon={faChevronDown} />
          )}
        />
      </div>
      <Collapse in={isExpanded}>
        <QueueAvailability />
        <QueueAvailability />
        <QueueAvailability />
      </Collapse>
    </div>
  );
};
